<div class="modal">
  <div class="modal-ctn picker">

    <div class="options">
      <span class="picker-title">{{ 'UI.PICK.TEAM' | translate }}</span>
      <div class="controls">
        <df-input type="search" prefixIcon="heroMagnifyingGlass" allowClear
          [value]="textFilter" (valueChange)="textFilter = $event; filterTeams()" />
        <df-select ariaLabel="Location" [searchable]="false" [clearable]="false"
          [options]="locations | selectOptions:'code':'name'"
          [value]="locationCodeFilter" (selectionChange)="filterTeamsLocation($event)" />
        @if (translations) {
          <df-select ariaLabel="Market" [searchable]="false" [clearable]="false"
            [options]="marketOptions"
            [value]="selectedMarket" (selectionChange)="selectMarket($event)" />
        }
      </div>
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>


    <div class="teams picker-list">
      @for (team of displayedTeams; track team) {
        <div class="team picker-item">
          <div class="logo">
            <ng-icon name="heroUser" size="18"/>
            @if (team.teamMemberId?.toUpperCase().startsWith('EXT')) {
              <span class="tag">
                External
              </span>
            }
            @if (!team.teamMemberId?.toUpperCase().startsWith('EXT')) {
              <span>
                {{ team.teamMemberId }}
              </span>
            }
          </div>
          <div class="info">
            <a>{{ team.teamMemberFirstName }} {{ team.teamMemberName }}</a>
            <a>{{ team.teamMemberEmail }}</a>
          </div>
          <df-button size="sm" variant="primary" class="add" (onClick)="add(team)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

  </div>
</div>